<div class="landing-inversores__logo">
  <img [src]="logoImage" alt="Inviertis" width="36" height="36" class="landing-inversores__logo-mark" />
  <span class="landing-inversores__logo-text">Inviertis</span>
</div>
